var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"languages"},_vm._l((_vm.availableLangs),function(lang,index){return _c('div',{key:index,staticClass:"languages__lang",class:{ active: _vm.currentLocale === lang.locale },on:{"click":function($event){return _vm.switchLocale(lang.locale)}}},[_vm._v(" "+_vm._s(_vm.$t(lang.translation))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }